const sections = ['About', 'Portfolio', 'Contact'];

export default sections;
